module.exports = __webpack_public_path__ + "img/instagrma.e44f190.png";